import { render } from "./AccountPage.vue?vue&type=template&id=4b2bc269&scoped=true&ts=true"
import script from "./AccountPage.vue?vue&type=script&lang=ts"
export * from "./AccountPage.vue?vue&type=script&lang=ts"

import "./AccountPage.vue?vue&type=style&index=0&id=4b2bc269&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2bc269"]])

export default __exports__